/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: npm run preprocess:generate-new
 * Generated at: 2026-05-06T00:55:57.756Z
 *
 * Index of Russian training sections
 * Use lazy imports to load section data on demand
 */

export interface SectionMetadata {
  id: string;
  title: string;
  description: string;
  introducedChars: string[];
  isPrerequisite: boolean;
  prerequisites: string[];
  classCount: number;
  fileName: string;
}

export const russianSectionsMetadata: SectionMetadata[] = [
  {
    "id": "russian-home-row",
    "title": "Home Row",
    "description": "Master the home row with balanced left-right hand pairs",
    "introducedChars": [
      "а",
      "о",
      "в",
      "л",
      "ы",
      "д",
      "ф",
      "ж"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 7,
    "fileName": "section-1-home-row.ts"
  },
  {
    "id": "russian-top-row",
    "title": "Top Row",
    "description": "Reach up from home row with balanced pairs",
    "introducedChars": [
      "к",
      "г",
      "у",
      "ш",
      "ц",
      "щ",
      "й",
      "з"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 15,
    "fileName": "section-2-top-row.ts"
  },
  {
    "id": "russian-bottom-row",
    "title": "Bottom Row",
    "description": "Reach down from home row with balanced pairs",
    "introducedChars": [
      "м",
      "ь",
      "с",
      "б",
      "ч",
      "ю",
      "я",
      "."
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 18,
    "fileName": "section-3-bottom-row.ts"
  },
  {
    "id": "russian-middle-keys",
    "title": "Middle Keys",
    "description": "Index finger reaches inward to middle columns",
    "introducedChars": [
      "п",
      "р",
      "е",
      "н",
      "и",
      "т"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 10,
    "fileName": "section-4-middle-keys.ts"
  },
  {
    "id": "russian-extended",
    "title": "Extended Characters",
    "description": "Letters that live on punctuation keys: х, ъ, э, ё",
    "introducedChars": [
      "х",
      "э",
      "ъ",
      "ё"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 7,
    "fileName": "section-5-extended.ts"
  },
  {
    "id": "russian-numbers",
    "title": "Numbers",
    "description": "Number row 0-9 with balanced left-right pairs",
    "introducedChars": [
      "5",
      "6",
      "4",
      "7",
      "3",
      "8",
      "2",
      "9",
      "1",
      "0"
    ],
    "isPrerequisite": true,
    "prerequisites": [],
    "classCount": 9,
    "fileName": "section-6-numbers.ts"
  }
];

/**
 * Lazy-load a section by ID.
 * Uses an explicit switch with static import paths so Vite can statically
 * analyze and code-split each section bundle.
 */
export async function loadRussianSection(sectionId: string) {
  switch (sectionId) {
    case 'russian-home-row':
      return (await import('./section-1-home-row')).section;
    case 'russian-top-row':
      return (await import('./section-2-top-row')).section;
    case 'russian-bottom-row':
      return (await import('./section-3-bottom-row')).section;
    case 'russian-middle-keys':
      return (await import('./section-4-middle-keys')).section;
    case 'russian-extended':
      return (await import('./section-5-extended')).section;
    case 'russian-numbers':
      return (await import('./section-6-numbers')).section;
    default:
      throw new Error(`Section not found: ${sectionId}`);
  }
}
